'use client';

import { useEffect } from 'react';
import { FbtContextType, useFbtContext } from './fbt-context-provider';
import { isEmpty } from '@cat-ecom/common/utils/commonUtils';
import { areEqualArrays } from 'components/price-and-fitment-context-entry/utils';

interface FbtContextCommonEntryProps {
  listenerKey: string;
  subTotal?: FbtContextType['subTotal'];
  fbtProductsWithPrice?: FbtContextType['fbtProductsWithPrice'];
  currency?: FbtContextType['currency'];
}

const FbtContextCommonEntry = ({
  listenerKey,
  subTotal: subTotalProps,
  fbtProductsWithPrice: fbtProductsWithPriceProps,
  currency: currencyProps
}: FbtContextCommonEntryProps) => {
  const {
    subTotal,
    setSubTotal,
    fbtProductsWithPrice,
    setFbtProductsWithPrice,
    currency,
    setCurrency
  } = useFbtContext();

  useEffect(() => {
    const subTotalPropsArray = Object.keys(subTotalProps ?? {});
    const subTotalArray = Object.keys(subTotal ?? {});
    if (
      !isEmpty(subTotalPropsArray) &&
      !areEqualArrays(subTotalPropsArray, subTotalArray)
    ) {
      setSubTotal(subTotalProps);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listenerKey, subTotalProps]);

  useEffect(() => {
    const fbtProductsWithPricePropsArray = Object.keys(fbtProductsWithPriceProps ?? {});
    const fbtProductsWithPriceArray = Object.keys(fbtProductsWithPrice ?? {});
    if (
      !isEmpty(fbtProductsWithPricePropsArray) &&
      !areEqualArrays(fbtProductsWithPricePropsArray, fbtProductsWithPriceArray)
    ) {
      setFbtProductsWithPrice(fbtProductsWithPriceProps);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listenerKey, fbtProductsWithPriceProps]);

  useEffect(() => {
    if (currencyProps !== currency) {
      setCurrency(currencyProps);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listenerKey, currencyProps]);

  return null;
};

export default FbtContextCommonEntry;
